module.exports = __webpack_public_path__ + "img/img_desc.e35d167f.png";